import React, { FC} from 'react';
import Lottie from 'react-lottie';
import animationData from '../../assets/animation/mixer__loading.json';
import './style.scss';

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
};

interface IPreloader {
  height? : string
}

const Preloader: FC<IPreloader> = ({height}) => {
  return (
    <div className="preloader" style={{height: height}}>
      <Lottie
        options={defaultOptions}
        width={130}
        height={130}
      />
    </div>
  )
};

export default Preloader;

